import { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom"; // 🔴 ADDED useNavigate
import axios from "axios";
import carhubLogo from "../assets/carLogo/carhubLogo.png";
import { ReactComponent as SearchIcon } from "../assets/icons/search-icon.svg";
import userIcon from "../assets/icons/userIcon.png"; 
import { useAuth } from "../AuthContext"; 

function HeaderNavbar() {
  const navigate = useNavigate(); // 🔴 ADDED for logout redirect
  const { user, logout } = useAuth(); 

  const [isOpen, setIsOpen] = useState(false);
  const [showSearchBox, setShowSearchBox] = useState(false);
  const [isExploreDropdownOpen, setIsExploreDropdownOpen] = useState(false);
  const [isUsedCarsOpen, setIsUsedCarsOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
  const [isMobileServicesDropdownOpen, setIsMobileServicesDropdownOpen] = useState(false);
  const [isMobileUsedOpen, setIsMobileUsedOpen] = useState(false);

  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);

  const exploreRef = useRef();
  const servicesRef = useRef();

//   // 🔴 ADDED: Logout handler
//   const handleLogout = () => {
//   logout();
//   navigate("/");
// };

  const handleLogout = () => {
    logout();
    setIsUserDropdownOpen(false); // 🔴 close dropdown
    navigate("/");
  };

  // 🔎 Search related state
  const [searchTerm, setSearchTerm] = useState("");
  const [searching, setSearching] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [allCars, setAllCars] = useState([]);

  // ✋ Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (exploreRef.current && !exploreRef.current.contains(event.target)) {
        setIsExploreDropdownOpen(false);
      }
      if (servicesRef.current && !servicesRef.current.contains(event.target)) {
        setIsServicesDropdownOpen(false);
      }
      if (!event.target.closest(".user-menu")) {
        setIsUserDropdownOpen(false);
      }
    };
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
    
    // To make your off-canvas (mobile) menu close when a user clicks outside of it
    useEffect(() => {
    const handleOutsideClick = (event) => {
      // Only trigger if menu is open
      if (isOpen) {
        const offcanvas = document.querySelector(".offcanvas-menu");
        // Close if the click is outside of the offcanvas area
        if (offcanvas && !offcanvas.contains(event.target)) {
          setIsOpen(false);
        }
      }
    };
    
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isOpen]);
  
  const toggleSearchBox = () => {
    setShowSearchBox((prev) => !prev);
    setSearchTerm("");
    setSearchResults([]);
  };

  // 🧯 Load cars once when opening the search box (to filter locally)
  useEffect(() => {
    const fetchCars = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/cars`);
        setAllCars(res.data || []);
      } catch (err) {
        console.error("Error fetching cars for search:", err);
        setAllCars([]);
      }
    };

    if (showSearchBox && allCars.length === 0) {
      fetchCars();
    }
  }, [showSearchBox, allCars.length]);

  // 🔍 Search as you type (debounced)
  useEffect(() => {
    if (!showSearchBox) return;

    if (searchTerm.trim().length === 0) {
      setSearchResults([]);
      setSearching(false);
      return;
    }

    setSearching(true);

    const timeout = setTimeout(() => {
      const term = searchTerm.toLowerCase();

      const results = allCars.filter((car) => {
        // Safeguard against null values
        const title = (car.title || "").toLowerCase();
        const brand = (car.brand || "").toLowerCase();
        const model = (car.model || "").toLowerCase();
        const fuel = (car.fuel || "").toLowerCase();
        const year = (car.year || "").toLowerCase();
        const location = (car.location || "").toLowerCase();

        return (
          title.includes(term) ||
          brand.includes(term) ||
          model.includes(term) ||
          fuel.includes(term) ||
          year.includes(term) ||
          location.includes(term)
        );
      });

      setSearchResults(results);
      setSearching(false);
    }, 300); // debounce 300ms

    return () => clearTimeout(timeout);
  }, [searchTerm, showSearchBox, allCars]);

  return (
    <>
      {/* Navbar */}
      <div className="container-fluid header-container d-flex align-items-center px-3 py-2">
        {/* Left Side */}
        <div className="d-flex align-items-center me-3">
          <button className="btn btn-sm d-lg-none me-2" onClick={() => setIsOpen(true)}
            style={{background: "transparent", border: "none", color: "#fff", fontSize: "24px", cursor: "pointer"}}
            >
            ☰
          </button>
          <Link to="/" className="navbar-brand mb-0 ms-3" 
          // style={{ marginLeft: "50px" }}
          >
            <img
              src={carhubLogo}
              alt="EthiocarHub Logo"
              className="logo-img"
              // style={{ height: "60px", width: "auto", filter: "brightness(0) invert(1)" }}
            />
          </Link>
        </div>
          
        {/* Center Nav */}
        <div className="d-none d-lg-flex align-items-center  center-nav">
          <Link className="text-white text-decoration-none hover-white-bg" to="/cars">
            Car Listing
          </Link>
          <Link className="text-white text-decoration-none hover-white-bg" to="/cars?sellerType=private">
            Private Sellers
          </Link>
          <Link className="text-white text-decoration-none hover-white-bg" to="/cars?sellerType=broker">
            Brokers
          </Link>
          <Link className="text-white text-decoration-none hover-white-bg" to="/cars?sellerType=dealership">
            Dealerships
          </Link>

          {/* Explore Cars Dropdown */}
          <div className="dropdown position-relative" ref={exploreRef}>
            <span
              className="text-white text-decoration-none hover-white-bg"
              role="button"
              onClick={() => setIsExploreDropdownOpen(!isExploreDropdownOpen)}
              style={{ cursor: "pointer" }}
            >
              Explore Cars {isExploreDropdownOpen ? "▴" : "▾"}
            </span>
        
            {isExploreDropdownOpen && (
              <ul className="dropdown-menu dropdown-menu-dark show" style={{ fontSize: "12px" }}>
                <li>
                  <Link
                    className="dropdown-item"
                    to="/cars?condition=brand-new"
                    onClick={() => setIsExploreDropdownOpen(false)}
                  >
                    New Cars
                  </Link>
                </li>
                {/* Used Cars with sub-menu */}
                <li className="dropdown-submenu">
                  <span
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsUsedCarsOpen((prev) => !prev);
                    }}
                  >
                    Used Cars {isUsedCarsOpen ? "▴" : "▾"}
                  </span>
                  {isUsedCarsOpen && (
                    <ul
                      className="dropdown-menu dropdown-menu-dark show"
                      style={{ fontSize: "12px", position: "absolute", left: "100%", top: 0 }}
                    >
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/cars?condition=foreign-used"
                          onClick={() => setIsExploreDropdownOpen(false)}
                        >
                          Foreign Used
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/cars?condition=local-used"
                          onClick={() => setIsExploreDropdownOpen(false)}
                        >
                          Local Used
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
                  <Link className="dropdown-item" to="/cars?type=electric" onClick={() => setIsExploreDropdownOpen(false)}>
                    Electric Cars (EV)
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/cars?purpose=rent" onClick={() => setIsExploreDropdownOpen(false)}>
                    Cars for Rent
                  </Link>
                </li>
                <li>
                  <span
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShowSearchBox(true);
                      setIsExploreDropdownOpen(false);
                    }}
                  >
                    Search Cars
                  </span>
                </li>
              </ul>
            )}
          </div>

          {/* More Services Dropdown (Desktop) */}
          <div className="dropdown position-relative ms-3" ref={servicesRef}>
            <span
              className="text-white text-decoration-none hover-white-bg"
              role="button"
              onClick={() => setIsServicesDropdownOpen(!isServicesDropdownOpen)}
              style={{ cursor: "pointer" }}
            >
              More Services {isServicesDropdownOpen ? "▴" : "▾"}
            </span>
            {isServicesDropdownOpen && (
              <ul className="dropdown-menu dropdown-menu-dark show" style={{ fontSize: "12px" }}>
                <li>
                  <Link className="dropdown-item" to="/importers-exporters" onClick={() => setIsServicesDropdownOpen(false)}>
                    Importers / Exporters
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/automotive-engineers" onClick={() => setIsServicesDropdownOpen(false)}>
                    Automotive Engineers
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/repair-services" onClick={() => setIsServicesDropdownOpen(false)}>
                    Repair & Services
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/spare-parts" onClick={() => setIsServicesDropdownOpen(false)}>
                    Spare Parts Dealers
                  </Link>
                </li>
              </ul>
            )}
          </div>
        </div>

        {/* Right Side */}
        <div className="d-flex align-items-center nav-right">
          <button className="search-icon-link border-0 bg-transparent p-0" title="Search" onClick={toggleSearchBox}>
            <SearchIcon style={{ width: "20px", height: "20px" }} />
          </button>

          {/* 🔴 ADDED: Desktop Auth Buttons */}

            {/* {!user ? (
              <>
                <Link to="/signup" className="text-white text-decoration-none hover-white-bg">
                  Sign up
                </Link>
                <Link to="/login" className="post-car-btn text-white d-none d-md-inline hover-white-bg">
                  Post Car
                </Link>
              </>
            ) : (
              <>
                <Link to="/post" className="post-car-btn text-white d-none d-md-inline hover-white-bg">
                  Post Car
                </Link>
                <button
                  onClick={handleLogout}
                  className="btn btn-link text-white text-decoration-none"
                >
                  Logout
                </button>
              </>
          )} */}
            
                          {/* 👤 User Dropdown */}
              <div className="user-menu position-relative ms-3">
                <button
                  onClick={() => setIsUserDropdownOpen((prev) => !prev)}
                  className="btn user-btn-link bg-transparent p-0"
                  // hover-white-bg p-0 ms-3"
                  style={{ cursor: "pointer"}}
                >
                  {/* 👤 */} 
                  <img
                    src={userIcon}
                    alt="User"
                    style={{
                      width: "22px",
                      height: "22px",
                      objectFit: "contain"
                    }}
                  />
                </button>

                {isUserDropdownOpen && (
                  <ul
                    className="dropdown-menu dropdown-menu-dark show"
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: 0,
                      fontSize: "14px",
                      minWidth: "160px",
                    }}
                  >
                    {!user ? (
                      <>
                        <li>
                          <Link className="dropdown-item" to="/login" onClick={() => setIsUserDropdownOpen(false)}>
                            Login
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/signup" onClick={() => setIsUserDropdownOpen(false)}>
                            Sign Up
                          </Link>
                        </li>
                      </>
                    ) : (
                      <>
                        <li>
                          <span className="dropdown-item fw-bold">
                            {user.name || user.email}
                          </span>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/account" onClick={() => setIsUserDropdownOpen(false)}>
                            Account
                          </Link>
                        </li>
                        <li className="d-lg-none">
                          <Link className="dropdown-item" to="/post" onClick={() => setIsUserDropdownOpen(false)}>
                            Post Car
                          </Link>
                        </li>
                        <li>
                          <button className="dropdown-item" onClick={handleLogout}>
                            Logout
                          </button>
                        </li>
                      </>
                    )}
                  </ul>
                )}
              </div>
              
              {/* Post Car — DESKTOP ONLY */}
              <Link
                to={user ? "/post" : "/login"} // 🔴 CHANGED
                className="post-car-btn text-white d-none d-md-inline hover-white-bg"
              >
                Post Car
              </Link>
            
        </div>
      </div>


      {/* 🔎 Search Box & Results */}
      {showSearchBox && (
        <>
          <div
            className="position-fixed px-2 d-flex align-items-center"
            style={{
              top: "80px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "90%",
              maxWidth: "400px",
              height: "44px",
              backgroundColor: "white",
              borderRadius: "999px",
              padding: "4px 12px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
              zIndex: 1200,
            }}
          >
            <SearchIcon style={{ width: "18px", height: "18px", marginRight: "8px", stroke: "#444", flexShrink: 0}} />
            <input
              type="text"
              className="search-input"
              placeholder="Search cars by title, brand, model, fuel..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                flex: 1,
                border: "none",
                outline: "none",
                fontSize: "14px",
                backgroundColor: "transparent",
                padding: "4px 0",
              }}
            />
            <button
              onClick={() => {
                setShowSearchBox(false);
                setSearchTerm("");
                setSearchResults([]);
              }}
              className="btn btn-sm btn-link text-dark px-1"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              ✕
            </button>
          </div>

          {/* Search Results Overlay */}
          <div
            className="position-fixed"
            style={{
              top: "128px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "90%",        
              maxWidth: "400px",  
              maxHeight: "260px",
              overflowY: "auto",
              background: "#fff",
              borderRadius: "10px",
              boxShadow: "0 4px 12px hsla(0, 0%, 0%, 0.20)",
              zIndex: 1200,
            }}
          >
            {searching ? (
              <div className="p-2 small text-muted">Searching cars…</div>
            ) : searchTerm.trim() !== "" && searchResults.length === 0 ? (
              <div className="p-2 small">No cars found.</div>
            ) : (
              searchResults.map((car) => {
                let imageSrc = "https://via.placeholder.com/60";
                try {
                  const imgs = JSON.parse(car.images || "[]");
                  if (imgs.length > 0) imageSrc = `${process.env.REACT_APP_API_URL}${imgs[0]}`;
                } catch (_) {}
              
                return (
                  <Link
                    to={`/cars/${car.slug}`}
                    key={car.id}
                    className="d-flex align-items-center text-decoration-none text-dark p-2"
                    onClick={() => {
                      setShowSearchBox(false);
                      setSearchTerm("");
                      setSearchResults([]);
                    }}
                    style={{ borderBottom: "1px solid #eee" }}
                  >
                    <img
                      src={imageSrc}
                      alt={car.title}
                      style={{ width: "50px", height: "40px", objectFit: "cover", borderRadius: "4px", marginRight: "8px" }}
                    />
                    <div style={{ fontSize: "12px", lineHeight: "1.2" }}>
                      <div className="fw-bold" style={{ fontSize: "12px" }}>
                        {car.title}
                      </div>
                      <div style={{ color: "green", fontSize: "11px" }}>
                        ETB {Number(car.price || 0).toLocaleString()}
                      </div>
                      <div className="text-muted" style={{ fontSize: "10px" }}>
                        {car.brand} {car.model} • {car.fuel} • {car.location}
                      </div>
                    </div>
                  </Link>
                );
              })
            )}
          </div>
        </>
      )}
      
      {/* Offcanvas Mobile Menu */}
      <div style={{ paddingTop: "40px" }}>
        <div
          className={`offcanvas-menu ${isOpen ? "open" : ""}`}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "295px",
            height: "100%",
            backgroundColor: "#f8f9fa",
            padding: "20px",
            transform: isOpen ? "translateX(0)" : "translateX(-100%)",
            transition: "transform 0.3s ease-in-out",
            zIndex: 1050,
          }}
        >
          <span
            onClick={() => setIsOpen(false)}
            style={{
              position: "absolute",
              top: "8px",
              right: "12px",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: "pointer",
              color: "#333",
            }}
          >
            ✕
          </span>
          
           {/* Tagline inside mobile menu */}
          <div
            className="brand-tagline text-center text-dark py-2"
            style={{ fontSize: "14px", fontWeight: "500" }}
        >
            EthiocarHub – Hub for all cars in Ethiopia | Buy, Sell & Rent
          </div>
            
          <div className="mobileNav">
            <Link onClick={() => setIsOpen(false)} className="d-block mb-2 text-dark text-decoration-none" to="/cars">
              Car Listing
            </Link>
            <Link onClick={() => setIsOpen(false)} className="d-block mb-2 text-dark text-decoration-none" to="/cars?sellerType=private">
              Private Sellers
            </Link>
            <Link onClick={() => setIsOpen(false)} className="d-block mb-2 text-dark text-decoration-none" to="/cars?sellerType=broker">
              Brokers
            </Link>
            <Link onClick={() => setIsOpen(false)} className="d-block mb-2 text-dark text-decoration-none" to="/cars?sellerType=dealership">
              Dealerships
            </Link>
            
            {/* Explore Cars (mobile) */}
            <div>
              <div
                className="mb-1 d-flex justify-content-between align-items-center"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setIsMobileDropdownOpen((prev) => !prev);
                  setIsMobileServicesDropdownOpen(false);           
                }}
              >
                <span>Explore Cars</span>
                <span>{isMobileDropdownOpen ? "▴" : "▾"}</span>
              </div>
              {isMobileDropdownOpen && (
                <>
                  <Link onClick={() => setIsOpen(false)} className="d-block mb-2 text-dark text-decoration-none ps-2" to="/cars?condition=brand-new">
                    New Cars
                  </Link>

                  <div
                    className="d-block mb-2 ps-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => setIsMobileUsedOpen((prev) => !prev)}
                  >
                    Used Cars {isMobileUsedOpen ? "▴" : "▾"}
                  </div>
                  {isMobileUsedOpen && (
                    <>
                      <Link onClick={() => setIsOpen(false)} className="d-block mb-2 text-dark text-decoration-none ps-4" to="/cars?condition=foreign-used">
                        Foreign Used
                      </Link>
                      <Link onClick={() => setIsOpen(false)} className="d-block mb-2 text-dark text-decoration-none ps-4" to="/cars?condition=local-used">
                        Local Used
                      </Link>
                    </>
                  )}

                  <Link onClick={() => setIsOpen(false)} className="d-block mb-2 text-dark text-decoration-none ps-2" to="/cars?type=electric">
                    Electric Cars (EV)
                  </Link>

                  <Link onClick={() => setIsOpen(false)} className="d-block mb-2 text-dark text-decoration-none ps-2" to="/cars?purpose=rent">
                    Cars for Rent
                  </Link>

                  <div
                    className="d-block mb-2 ps-2 text-dark"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setIsOpen(false);
                      setShowSearchBox(true);
                    }}
                  >
                    Search Cars
                  </div>
                </>
              )}
            </div>

            {/* More Services (mobile) */}
            <div>
              <div
                className="mb-1 d-flex justify-content-between align-items-center"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setIsMobileServicesDropdownOpen((prev) => !prev);
                  setIsMobileDropdownOpen(false);
                  setIsMobileUsedOpen(false);
                }}
              >
                <span>More Services</span>
                <span>{isMobileServicesDropdownOpen ? "▴" : "▾"}</span>
              </div>

              {isMobileServicesDropdownOpen && (
                <>
                  <Link onClick={() => setIsOpen(false)} className="d-block mb-2 text-dark text-decoration-none ps-2" to="/importers-exporters">
                    Importers / Exporters
                  </Link>
                  <Link onClick={() => setIsOpen(false)} className="d-block mb-2 text-dark text-decoration-none ps-2" to="/automotive-engineers">
                    Automotive Engineers
                  </Link>
                  <Link onClick={() => setIsOpen(false)} className="d-block mb-2 text-dark text-decoration-none ps-2" to="/repair-services">
                    Repair & Services
                  </Link>
                  <Link onClick={() => setIsOpen(false)} className="d-block mb-2 text-dark text-decoration-none ps-2" to="/spare-parts">
                    Spare Parts Dealers
                  </Link>
                </>
              )}
            </div>
            {/* 🔴 Mobile Auth Buttons */}
              {!user ? (
                <Link onClick={() => setIsOpen(false)} to="/login" className="d-block mb-2 text-dark text-decoration-none"
                >
                  Post Car
                </Link>
              ) : (
                <>
                  <Link onClick={() => setIsOpen(false)} to="/post" className="d-block mb-2 text-dark text-decoration-none"
                  >
                    Post Car
                  </Link>
                  
                  <button
                    onClick={() => {
                      handleLogout();
                      setIsOpen(false); // ✅ close mobile menu on logout
                    }}
                    className="d-block mb-2 text-dark"
                    style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      cursor: "pointer",
                    }}
                  >
                    Logout
                  </button>
                </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default HeaderNavbar;

